import { jsxs as C, jsx as r } from "react/jsx-runtime";
import W, { useRef as X, useState as n, useEffect as k } from "react";
import { getContrastColor as R } from "../../utils/colors.js";
import { Iconify as b } from "../Iconify/index.js";
import { isMobile as E } from "../../utils/devices.js";
import '../../assets/Carousel.css';let h = "right";
const U = ({
  children: c,
  controls: d,
  controlsBackgroundColor: N
}) => {
  const t = X(null), [i, S] = n(0), [f, m] = n(0), [g, p] = n(!1), [v, y] = n(!1), a = N || "#ffffff", L = R(a, !0), D = 3e3;
  k(() => {
    let e;
    return !v && !E && (e = setInterval(P, D)), () => clearInterval(e);
  }, [v]);
  const I = () => y(!0), x = () => y(!1), P = () => {
    if (t.current) {
      const e = t.current, o = e.querySelector(
        ".simply-carousel-item-video"
      ), l = o.offsetWidth * W.Children.count(c);
      h === "right" ? e.scrollLeft + e.offsetWidth >= l ? h = "left" : e.scrollLeft += o.offsetWidth : e.scrollLeft === 0 ? h = "right" : e.scrollLeft -= o.offsetWidth;
    }
  }, s = (e) => {
    if (t.current) {
      const o = t.current.querySelector(
        ".simply-carousel-item-video"
      ), l = o.offsetWidth * W.Children.count(c), T = o.offsetWidth * (e === "left" ? -1 : 1);
      t.current.scrollLeft += T, e === "right" && t.current.scrollLeft + t.current.offsetWidth >= l && (t.current.scrollLeft = 0), e === "left" && t.current.scrollLeft === 0 && (t.current.scrollLeft = l);
    }
  }, M = (e) => {
    S(e), m(e), p(!0);
  }, w = (e) => {
    g && m(e);
  }, u = () => {
    g && (p(!1), console.log({ startPosition: i, endPosition: f }), i - f > 50 ? s("right") : i - f < -50 && s("left"));
  };
  return /* @__PURE__ */ C(
    "div",
    {
      style: { marginTop: d && !E ? -50 : 0 },
      className: "simply-carousel-container",
      onMouseEnter: I,
      onMouseLeave: x,
      children: [
        d && /* @__PURE__ */ C("div", { className: "simply-carousel-controls", children: [
          /* @__PURE__ */ r(
            "button",
            {
              style: { backgroundColor: a },
              className: "simply-carousel-arrow left-arrow",
              onClick: () => s("left"),
              children: /* @__PURE__ */ r(
                b,
                {
                  icon: "carbon:arrow-left",
                  color: L,
                  width: 14,
                  height: 14
                }
              )
            }
          ),
          /* @__PURE__ */ r(
            "button",
            {
              style: { backgroundColor: a },
              className: "simply-carousel-arrow right-arrow",
              onClick: () => s("right"),
              children: /* @__PURE__ */ r(
                b,
                {
                  icon: "carbon:arrow-right",
                  color: L,
                  width: 14,
                  height: 14
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ r(
          "div",
          {
            className: "simply-carousel",
            ref: t,
            onTouchStart: (e) => M(e.touches[0].clientX),
            onTouchMove: (e) => w(e.touches[0].clientX),
            onTouchEnd: u,
            onMouseDown: (e) => M(e.clientX),
            onMouseMove: (e) => w(e.clientX),
            onMouseUp: u,
            onMouseLeave: u,
            children: c
          }
        )
      ]
    }
  );
};
export {
  U as default
};
